import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { get } from 'lodash'
import { FormattedMessage } from 'react-intl'
import { Link } from 'react-router-dom'
import { compose } from 'recompose'
import { ButtonGroup } from 'components/misc'
import uuid from 'uuid'
import { getActiveRole } from 'utils/token'
import { ROLES } from 'constants/enums'
import styles from './tabs.styl'
import { Button } from '../../misc'

const enhance = compose(
  connect(({ auth, api }) => ({
    activeOrganization: auth.organization,
    configuration: api.configuration
  }))
)

class Tabs extends Component {
  static propTypes = {
    organisationId: PropTypes.string,
    activeOrganization: PropTypes.object,
    configuration: PropTypes.object,
    route: PropTypes.object,
    overview: PropTypes.object,
    links: PropTypes.array,
    isRestricted: PropTypes.bool,
    location: PropTypes.object
  }

  static defaultProps = {
    configuration: {}
  }

  handleGetCountNumber = (counters = []) => {
    const { overview, organisationId } = this.props

    let counts = []

    if (!overview) {
      return null
    }

    let list = overview.list

    if (organisationId) {
      // if API call fails then byId will be empty and [] should return to prevent displaying wrong count
      list = overview.byId[organisationId] || []
    }

    counters.forEach(nameId => {
      counts = counts.concat(
        list.filter(item => item.nameId === nameId).map(item => item.value)
      )
    })

    const count = counts.reduce((acc, cv) => {
      return acc + cv
    }, 0)

    if (!count) {
      return null
    }
    return <span className={styles.progress}>{count}</span>
  }

  getMaxLevel = (parts, item) => {
    return parts.includes('bo') ? item.maxLevel + 1 : item.maxLevel
  }

  render() {
    const {
      links,
      location,
      isRestricted,
      activeOrganization,
      route,
      configuration,
      params
    } = this.props

    let tabsLinks = links

    if (isRestricted) {
      tabsLinks = tabsLinks.filter(item => item.authorized)
    }

    const role = getActiveRole(activeOrganization)

    tabsLinks = tabsLinks.filter(link => {
      if (link.configs) {
        return link.configs.some(item => {
          const boolValue =
            get(
              configuration,
              `valuesByOrganizationId[${Number(params.id)}][${item}].booleanValue`
            ) || get(configuration, `values[${item}].booleanValue`)

          return (
            boolValue &&
            link.roles.some(
              itemRole => itemRole === role || itemRole === ROLES.ALL.u
            )
          )
        })
      }

      if (link.roles) {
        return link.roles.some(
          itemRole => itemRole === role || itemRole === ROLES.ALL.u
        )
      }

      return link
    })

    if (get(route, 'isTypeId')) {
      tabsLinks = tabsLinks.filter(link => {
        if (link.displayForOrganizationTypes) {
          return link.displayForOrganizationTypes.some(
            orgId => orgId === route.isTypeId
          )
        }
        return link
      })
    }

    const bestMatch = tabsLinks.filter(item => item.type !== 'action').reduce((acc, item) => {
      return location && location.pathname.includes(item.path) && (item.path.length > acc.length)
        ? item.path
        : acc
    }, '')
    const items = tabsLinks.filter(item => item.type !== 'action').map(item => {
      const active = (item.path === bestMatch)
        ? styles.active
        : ''

      let prefix = location && location.pathname

      let parts = prefix.split('/')

      parts = item.maxLevel
        ? parts.slice(0, this.getMaxLevel(parts, item))
        : parts.slice(0, -1)
      prefix = parts.join('/')

      if (item.visibility === 'hidden') {
        return null
      }

      return (
        <li
          className={`${styles.item} ${item.tabClassName ? styles[item.tabClassName] : ''}`}
          key={uuid.v1()}
        >
          <Link
            className={`${styles.link} ${active} ${item.className ? styles[item.className] : ''}`}
            to={prefix + item.path}
          >
            {item.intlKey
              ? <FormattedMessage
                  id={item.intlKey}
                  defaultMessage={item.label}
                />
              : item.label}
            {item.counters && this.handleGetCountNumber(item.counters)}
          </Link>
        </li>
      )
    })

    const actions = tabsLinks
      .filter(item => item.type === 'action')
      .map((item, index) => {
        const secondaryClass = item.secondary ? 'secondary' : ''

          if(item.path){
            return (<Link key={index} to={item.path} className={`btn ${secondaryClass}`}>
              {item.intlKey
                ? <FormattedMessage
                  id={item.intlKey}
                  defaultMessage={item.label}
                />
                : item.label}
            </Link>)
          }

        if(item.func) {
            return (<button type='button' onClick={item.func} className={`btn ${secondaryClass}`}>
              {item.intlKey
                ? <FormattedMessage
                  id={item.intlKey}
                  defaultMessage={item.label}
                />
                : item.label}
            </button>)
          }

      })

    return (
      <div className={styles.wrap}>
        <ul className={styles.list}>{items}</ul>
        <div className={styles.actions}>
          <ButtonGroup>{actions}</ButtonGroup>
        </div>
      </div>
    )
  }
}

export default enhance(Tabs)
